import { render, staticRenderFns } from "./TitleCover.vue?vue&type=template&id=9dfce430&scoped=true&"
import script from "./TitleCover.vue?vue&type=script&lang=js&"
export * from "./TitleCover.vue?vue&type=script&lang=js&"
import style0 from "./TitleCover.vue?vue&type=style&index=0&id=9dfce430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfce430",
  null
  
)

export default component.exports